import i18n from '@/i18n'
import { filterRulesMapped } from '@/tools/filterRules'
import { thingService } from '@/services/thing.service'
import { enterpriseService } from '@/services/enterprise.service'
import { mapActions, mapGetters } from 'vuex'
import { DialogType, SnackbarStyle, TypeIcons } from '@/constants/constants'
import { dialogTypes } from '@/constants/dialogTypes'
import ThingDialogComponent from '@/components/thing/dialog/ThingDialogComponent.vue'
import MassiveUploadThingDialogComponent from '@/components/thing/massive-upload/MassiveUploadThingDialogComponent.vue'
import GpsDialogComponent from '@/components/gps/dialog/GpsDialogComponent.vue'
import { DialogThing, DialogMassiveUploadThing, dialogUtil } from '@/tools/dialog'
import LineDialogComponent from '@/components/line/dialog/LineDialogComponent.vue'
import GroupDialogComponent from '@/components/group/dialog/GroupDialogComponent.vue'
import FleetDialogComponent from '@/components/fleet/dialog/FleetDialogComponent.vue'
import WorkFrontDialogComponent from '@/components/work-front/dialog/WorkFrontDialogComponent.vue'
import EventDialogComponent from '@/components/event/EventDialogComponent.vue'
import EventTypeDialogComponent from '@/components/event-type/dialog/EventTypeDialogComponent.vue'
import StateTypeDialogComponent from '@/components/state-type/dialog/StateTypeDialogComponent.vue'
import { clone } from 'ramda'
import Vue from 'vue'
import AutocompleteComponent from '@/components/commons/autocomplete/AutocompleteComponent.vue'

export default {
    name: 'ThingABMComponent',
    components: {
        ThingDialogComponent,
        GpsDialogComponent,
        LineDialogComponent,
        GroupDialogComponent,
        FleetDialogComponent,
        WorkFrontDialogComponent,
        MassiveUploadThingDialogComponent,
        EventDialogComponent,
        EventTypeDialogComponent,
        StateTypeDialogComponent,
        AutocompleteComponent,
    },
    data: () => ({
        enterpriseIdSelected: "",
        typeSelectedId: "",
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los datos
        tableDataKey: 'id',
        // botones de cada fila
        rowActions: [
            // modificar
            {
                id: 1,
                name: i18n.t('modify'),
                color: 'blue',
                icon: 'fa-pen'
            },
            // eliminar
            {
                id: 2,
                name: i18n.t('delete'),
                color: 'red',
                icon: 'fa-trash-alt'
            },
            // usar como plantilla
            /*{
                id: 3,
                name: i18n.t('template'),
                color: 'green',
                icon: 'fa-clone'
            }*/
        ],
        // botones del componente tabla
        tableComponentButtons: [],
        // tamaño de página (paginador)
        pageSize: 0,
        // número de página (paginador)
        pageNumber: 1,
        // total de documentos de la base de datos (paginador)
        pageTotal: null,
        // configuración del dialog del ABM
        dialog: {
            ...dialogTypes.THING,
        },
        // boolean para activar el dialogo
        showDialog: false,
        // título del dialog de edición
        editDialogTitle: i18n.t('equipment.editDialog.titleNew'),
        // para activar el loading de la tabla
        loading: true,
        // arreglo de empresas para el selector de la tabla
        tableEnterpriseItems: [],
        // empresa seleccionada para filtrar las cosas de la tabla
        tableEnterpriseSelected: null,
        // arreglo de empresas para el selector de la tabla
        tableTypeItems: [],
        // tipo seleccionada para filtrar las cosas de la tabla
        tableTypeSelected: null,
        // Opción 'TODOS' para el selector de empresa
        all: {
            _id: 'ALL',
            name: i18n.t('all')
        },
        // bandera para desactivar los watchers de los selectores durante la carga inicial
        initialLoad: false,
        // configuración del dialog de carga masiva
        massiveUploadDialog: {
            ...dialogTypes.THING_MASSIVE_UPLOAD,
        },
        // model del dialog de carga masiva
        showMassiveUploadDialog: false,
        // banderas para identificar en la carga inicial si cambiaron los selectores
        enterpriseSelector: false,
        typeSelector: false,
        isClone: false
    }),
    computed: {
        /*
        ...mapState('breadcrumbs', {
            breads: state => state.breads
        }),
        */
        ...mapGetters('breadcrumbs', [
            'getBread'
        ]),
        /**
         * Devuelve un arreglo de empresas de acuerdo al valor del selector
         */
        abmSelectedEnterprises () {
            if (this.tableEnterpriseSelected) {
                if (this.tableEnterpriseSelected === 'ALL') {
                    return this.tableEnterpriseItems.filter(item => item._id !== 'ALL').map(item => item._id)
                } else {
                    return [this.tableEnterpriseSelected]
                }
            } else {
                return null
            }
            
        },
        /**
         * Devuelve un arreglo de tipos de acuerdo al valor del selector
         */
        abmSelectedTypes () {
            if (this.tableTypeSelected) {
                if (this.tableTypeSelected._id === 'ALL') {
                    return this.tableTypeItems.filter(item => item._id !== 'ALL').map(item => item._id)
                } else {
                    return [this.tableTypeSelected._id]
                }
            } else {
                return null
            }
        },
        /**
         * 
         */
        enterprises () {
            return this.tableEnterpriseItems.filter(items => items._id !== this.all._id)
        }
    },
    created() {
        /*
            Vuex watch del breadcrumb
        */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
                (newBreads) => {
                    const lastElemet = newBreads[newBreads.length - 1]
                    if (!lastElemet) {
                        this.cancel()
                        this.massiveUploadCancel()
                        return
                    }
                    this.dialog = dialogUtil.getDialog(lastElemet.key, DialogThing)
                    this.massiveUploadDialog = dialogUtil.getDialog(lastElemet.key, DialogMassiveUploadThing)
                },
            { deep: true })
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
        this.cleanBread()
    },
    async mounted() {
        // Botones de edición y eliminación múltiple
        this.tableComponentButtons.push(            
            {
                id: 'add-dialog',
                tooltip: i18n.t('add'),
                icon: 'add',
                action: this.showCreateDialog.bind(this),
                selectedData: false
            },
            {
                id: 'edit-dialog',
                tooltip: i18n.t('equipment.massiveUpload.name'),
                icon: 'mdi-table-large-plus',
                action: this.showThingMassiveUploadDialog.bind(this),
                selectedData: false
            },
            {
                id: 'masive-delete',
                tooltip: i18n.t('multipleDelete'),
                icon: 'delete_outline',
                action: this.deleteMany.bind(this),
                selectedData: true
            })
        await this.initialize()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * Inicialización del breadcrumb para alta/modificación
         */
        initBread() {
            const bread = {
                key: dialogTypes.THING.key,
                disabled: true,
                text: this.$t('equipment.name')
            }
            this.pushBread(bread)
        },
        /**
         * Inicialización del breadcrumb para carga masiva
         */
        initBreadMassiveUpload() {
            const bread = {
                key: dialogTypes.THING_MASSIVE_UPLOAD.key,
                disabled: true,
                text: this.$t('equipment.massiveUpload.name')
            }
            this.pushBread(bread)
        },
        /**
         * Este método se ejecuta para inicializar los datos de la tabla.
         * Carga el selector de emrpesas y el selector de tipos y ejecuta el método para cargar los datos de la tabla.
         */
        async initialize () {
            this.initialLoad = true

            // inicialización de los datos de selectores

            // tipos
            const types = await thingService.getTypesForSelector()
            if (types.length > 1) {
                this.tableTypeItems = [this.all]
                this.tableTypeItems = this.tableTypeItems.concat(types)
            } else {
                this.tableTypeItems = types
            }
            this.typesItems = types
            this.tableTypeSelected = this.tableTypeItems.length > 0 ? this.tableTypeItems[0] : null
            this.typeSelectedId = this.tableTypeSelected._id;
            // empresas
            const enterprises = await enterpriseService.getAllForSelector()
            if (enterprises.length > 1) {
                this.tableEnterpriseItems = [this.all]
                this.tableEnterpriseItems = this.tableEnterpriseItems.concat(enterprises)
                this.tableEnterpriseSelected = this.tableEnterpriseItems.length > 0 ? this.tableEnterpriseItems[1]._id : null
            } else {
                this.tableEnterpriseItems = enterprises
                this.tableEnterpriseSelected = this.tableEnterpriseItems.length > 0 ? this.tableEnterpriseItems[0]._id : null
            }
            this.enterpriseIdSelected = this.tableEnterpriseSelected;
            console.log(this.enterpriseIdSelected)

            // total de cosas
            this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes)

            // Si hay query params, los setea para incluirlos en la llamada al backend
            if (this.$route.query.pageSize && this.$route.query.pageNumber) {
                this.pageSize = Number(this.$route.query.pageSize)
                this.pageNumber = Number(this.$route.query.pageNumber)

                // Valida que los qery params sean correctos y completos
                if ((this.pageSize && this.pageSize <= 0) || (this.pageNumber && this.pageNumber <= 0) || (this.pageNumber && !this.pageSize) || (!this.pageNumber && this.pageSize)) {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('error.invalidQueryParams'),
                        timeout: 6000,
                        style: SnackbarStyle.ERROR
                    })
                    this.pageSize = this.pageTotal
                    this.pageNumber = 1
                }
            } else {
                this.pageSize = this.pageTotal
                this.pageNumber = 1
            }

            // cargo la tabla con las cosas filtradas de acuerdo a los valores del selector
            await this.getData()
            this.resetFields()
            this.initBread()
            this.initialLoad = false
        },
        /**
         * Este método se utiliza para obtener los datos de la tabla
         * @param {*} update
         */
        async getData(update = false) {
            this.loading = true
            if (update) {
                this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes)
                this.pageSize = 50
                this.pageNumber = 1
            }
            let data = await thingService.findAll(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes)
            
            if (this.enterpriseSelector || this.typeSelector) {
                this.enterpriseSelector = false
                this.typeSelector = false

                this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes)
                this.pageSize = 50
                this.pageNumber = 1

                data = await thingService.findAll(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes)
            }
            // Se clonan los headers anteriores para mantener las columnas seleccionadas
            const lastTableHeaders = clone(this.tableHeaders)
            this.tableData.cleanAndUpdate(data.data)
            if (update) {
                const that = this
                Vue.nextTick(function () {
                    that.tableHeaders.cleanAndUpdate(lastTableHeaders)
                })
            } else {
                this.tableHeaders.cleanAndUpdate(data.headers)
                this.setTableFilterRules()
            }
            this.loading = false
        },
        /**
         * Refrescar la data
         */
        async refreshTable() {
            await this.getData(true)
        },
        /**
         * Reglas de filtrado de la tabla
         */
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Reset el modelo del dialog de creación/actualización
         */
        resetFields() {
            if (this.dialog) {
                this.dialog.model = {
                    _id: null,
                    name: null,
                    description: null,
                    typeId: null,
                    gpsId: null,
                    enterpriseId: null,
                    countryId: null,
                    currentActivity: null,
                    harvestFrontId: null,
                    fleetId: null,
                    sectorId: null,
                    groupId: null,
                    identificator: null,
                    color: '#0694de',
                    features: null,
                    hasOnBoardMonitor: null,
                    originWorkWidth: null,
                    config: {},
                    boxQuantity: null,
                    update: false,
                    reminderBy: [],
                    consumption: {},
                    isClone: false,
                    commodatum: false,
                    caliper: {},           
                        serviceType:"",
                        varilla: {}
                    
                }
            }
        },
        /**
         * Eliminar un equipo
         * @param {*} id
         */
        deleteOne(id) {
            thingService.deleteOne(id).then(() => {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('equipment.successDeleteOneMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                })
                this.getData(true)
            })
        },
        /**
         * Eliminar muchos equipos
         * @param {*} data
         */
        async deleteMany(data) {
            this.openDialog({
                title: this.$t('equipment.deleteManyTitle'),
                text: this.$t('equipment.multipleDeleteText'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    thingService.deleteMany(data.map(element => element.id)).then(() => {
                        this.showSnackbar({
                            visible: true,
                            text: this.$t('equipment.successDeleteManyMessage'),
                            timeout: 6000,
                            style: SnackbarStyle.SUCCESS
                        })
                        this.getData(true)
                    })
                },
                noAction: () => {
                }
            })
        },
        /**
         * Carga los datos para actualizar un equipo
         * @param {*} id
         */
        async loadFields(id) {
            const thing = await thingService.getThing(id)
            
            if (thing) {
                thing.consumption = this.flattenConsumption(thing)
                this.dialog.model.isClone = this.isClone
                const model = this.dialog.model
                Object.assign(model, thing)
                this.showEditDialog()
            } else {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('equipment.error.couldNotLoadData'),
                    timeout: 6000,
                    style: SnackbarStyle.ERROR
                })
            }
        },
        /**
         * Acción de los botones de cada fila (editar o eliminar)
         * @param {*} button
         * @param {*} data
         */
        rowButtonClicked(button, data) {
            switch (button.id) {
                case 1:
                    // TO DO: agregar el id como query param
                    this.editDialogTitle = i18n.t('equipment.editDialog.titleEdit', {name: data.name})
                    this.isClone = false
                    this.loadFields(data._id)
                    break
                case 2:
                    this.openDialog({
                        title: this.$t('equipment.deleteOneTitle'),
                        text: this.$t('equipment.deleteOneText', { name: data.name }),
                        type: DialogType.QUESTION,
                        overlayOpacity: 0.5,
                        actionButtons: true,
                        yesAction: () => {
                            this.deleteOne(data._id)
                        },
                        noAction: () => {
                        }
                    })
                    break
                case 3:
                    this.editDialogTitle = i18n.t('equipment.editDialog.titleNew')
                    this.isClone = true
                    this.loadFields(data._id)
                    break
                default:
                    console.error('Botón no implementado')
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.resetFields()
            this.showDialog = false
        },
        /**
         * Cancelar dialog de carga masiva
         */
        massiveUploadCancel() {
            if (this.massiveUploadDialog) this.massiveUploadDialog.model.file = null
            this.showMassiveUploadDialog = false
        },
        /**
         * Abre el dialog para creación
         */
        showCreateDialog() {
            this.initBread()
            this.dialog.model.update = false
            this.editDialogTitle= i18n.t('equipment.editDialog.titleNew')
            this.showDialog = true
        },
        /**
         * Abre el dialog para edición
         */
        showEditDialog() {
            this.initBread()
            if (this.isClone) {
                this.dialog.model.name = undefined
                this.dialog.model.identificator = undefined
                this.dialog.model.gpsId = undefined
            }
            this.dialog.model.update = !this.isClone
            this.dialog.model.isClone = this.isClone
            this.showDialog = true
        },
        /**
         * Abre el dialog para carga masiva
         */
        showThingMassiveUploadDialog() {
            this.initBreadMassiveUpload()
            this.showMassiveUploadDialog = true
        },
        /**
         * Paginador externo
         * @param {*} pageSize
         * @param {*} pageNumber
         */
        externalPaginator(pageSize, pageNumber) {
            this.pageNumber = Number(pageNumber)
            this.pageSize = Number(pageSize)
        },
        /**
         * Esta función se ejecuta cuando alguno de los selectores (empresa o tipo) cambia
         */
        async updateData() {
            // total de cosas
            this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes)
            this.pageSize = this.pageTotal
            this.pageNumber = 1
            // datos
            await this.getData(true)
        },
        /**
         * Función que devuelve la imagen/icono del ABM según el tipo seleccionado
         *
         * Default: tractor
         * @param {*} typeKey
         */
        getTypeIcon(typeKey) {
            let icon = TypeIcons.DEFAULT
            if (typeKey) {
                icon = TypeIcons[typeKey] ? TypeIcons[typeKey] : TypeIcons.DEFAULT
            }
            return icon
        },
        /**
         * Cuando se selecciona una empresa
         * @param {*} newValue
         */
        tableEnterpriseSelectedFunction (newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableEnterpriseSelected = newValue._id ? newValue._id : newValue;
            if (!this.initialLoad) {
                this.updateData()
            } else {
                this.enterpriseSelector = true
            }
        },
        /**
         * Cuando se selecciona un tipo
         * @param {*} newValue
         */
        tableTypeSelectedFunction (newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableTypeSelected = newValue;
            if (!this.initialLoad) {
                this.updateData()
            } else {
                this.typeSelector = true
            }
        },
        /**
         * al editar un thing, aplana la configuración de consumo de combustible
         * para la lectura de 
         * @param {*} thing 
         */
        flattenConsumption(thing) {
            let consumption = {
                type: null,
                pricePerLitre: null,
                litres: null,
                from: null,
                to: null,
            };
            if(thing.consumption){
                if(typeof thing.consumption.litres === 'number') {
                    /**
                     * caso que contempla que ya exista un consumo configurado previo al añadido de soporte
                     * de configuracion de consumo en la ui.
                     */
                    consumption.type = thing.consumption.type ? thing.consumption.type : null;
                    consumption.litres = thing.consumption.litres ? thing.consumption.litres : null; 
                }
                else if (thing.consumption.litres.length > 0) {
                    /**
                     * caso que contempla que existan múltiples arreglos de rango de consumo (previo al agregado de soporte para config consumo en la ui)
                     * o en caso de que este guardado en un array de un único elemento (tal cual lo implementado en la ui y backend)
                     * se elije la primera opción debido a que es procesado de esta forma en las ME
                     */
                    consumption.type = thing.consumption.type ? thing.consumption.type : null;
                    consumption.pricePerLitre = thing.consumption.pricePerLitre ? thing.consumption.pricePerLitre : null;
                    consumption.litres = thing.consumption.litres[0].litres ? thing.consumption.litres[0].litres  : null; 
                    consumption.from = thing.consumption.litres[0].from ? thing.consumption.litres[0].from : null; 
                    consumption.to = thing.consumption.litres[0].to ? thing.consumption.litres[0].to : null; 
                }
            }
           /**
            * si no existia un consumption previamente, se retorna un objeto con sus atributos nulos.
            */
            return consumption
        }
    },
}
